export const courses = [

  {
    id: "101",
    title: "Certificate of Competency in Metal Scaffolding",
    instructor: "Greenmark Training Dept",
    instructorImage:
      "https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?auto=format&fit=crop&w=300&q=80",
    startDate: "Ongoing – Weekly",
    bannerImage:
      "/course1.avif",
    brochureLink: "/documents/Certificate of Competency in Metal Scaffolding.pdf",

    overview:
      "This course trains learners in the safe erection, modification, inspection, and dismantling of metal scaffolds according to industry and MOM safety standards. Participants will be taught scaffold component identification, load calculations, bracing configurations, height safety, fall prevention methods, and teamwork techniques required for scaffold assembly. The training emphasizes hands-on practice with real scaffold structures, enabling students to build stable platforms confidently under supervision. By completion, trainees develop an in-depth understanding of structural integrity, risk control, and safety compliance required for working at heights in construction and PCM sectors.",

    suitableFor: "Suitable for scaffold erectors and construction workers",

    modeOfTraining: "Classroom Training",
    language: "English",
    ITECoCTitle: {
      level1: "CoC in Metal Scaffolding – Level 1",
      level2: "CoC in Metal Scaffolding – Level 2",
    },

    learningOutcomes: [
      "Understand scaffold structures and safety standards",
      "Safe erection, modification and dismantling procedures",
      "Meet compliance requirements",
    ],
    soldCount: 1240,

    curriculum: [
      "Scaffold Safety and Regulations",
      "Erection and Dismantling Techniques",
      "Practical Assessment and Certification",
    ],

    certification: true,

    levels: {
      level1: {
        duration:
          "7 Hours (1h theory + 6h practical (including 5 hrs practical test))",
        price: 300,
        classRatio: "1:2",
        prerequisites: [
          "WSQ Perform Metal Scaffolding Work OR",
          "WSQ Perform Metal Scaffold Erection (PMSE) from ATPs",
        ],
      },
      level2: {
        duration:
          "21 Hours (4h theory + 17h practical (including 7 hrs practical test))",
        price: 900,
        classRatio: "1:2",
        prerequisites: [
          "WSQ Perform Metal Scaffolding Work OR",
          "ITE CoC in Metal Scaffolding – Level 1",
        ],
      },
    },
  },

  // ======================================================================
  {
    id: "102",
    title: "Certificate of Competency in Welding",
    instructor: "WSQ Certified Welding Trainer",
    instructorImage:
      "https://images.unsplash.com/photo-1607746882042-944635dfe10e?auto=format&fit=crop&w=300&q=80",
    startDate: "Ongoing – Weekly",
    bannerImage:
      "/product2.jpg",
    brochureLink: "/documents/Certificate of Competency in Welding.pdf",

    overview:
      "This course provides hands-on training in fundamental and advanced welding processes used in fabrication, construction, and industrial maintenance. Learners will understand welding metallurgy, equipment setup, electrode selection, torch control, joint preparation, and safety protocols. Practical sessions cover SMAW, MIG, and other core techniques with real welding booths that simulate field conditions. Students learn how to produce clean, strong welds and perform quality checks, preparing them for WSQ competency assessments and workplace welding tasks with confidence.",

    suitableFor: "Suitable for welders, metal workers, fabrication staff",

    modeOfTraining: "Classroom Training",
    language: "English",
    ITECoCTitle: {
      level1: "CoC in Welding – Level 1",
      level2: "CoC in Welding – Level 2",
    },

    learningOutcomes: [
      "Understand welding fundamentals and safety",
      "Perform controlled welds safely",
      "Pass WSQ competency assessment",
    ],
    soldCount: 850,

    curriculum: [
      "Welding Safety and Techniques",
      "Hands-On Welding Practice",
      "Practical Certification Assessment",
    ],

    certification: true,

    levels: {
      level1: {
        duration:
          "7 Hours (2h theory + 5h practical (including 2.25 hrs practical test))",
        price: 300,
        classRatio: "1:10",
        prerequisites: [
          "WSQ Perform Welding OR",
          "Composite Assessment for Generic Manufacturing (Process) OR",
          "Worker with R1 status through market-based",
        ],
      },
      level2: {
        duration:
          "21 Hours (7h theory + 14h practical (including 3.25 hrs practical test))",
        price: 900,
        classRatio: "1:10",
        prerequisites: [
          "WSQ Perform Welding OR",
          "ITE CoC in Welding – Level 1",
        ],
      },
    },
  },

  // ======================================================================

  {
    id: "103",
    title: "Certificate of Competency in Electrical Fitting (to be approved)",
    instructor: "Greenmark Training Dept",
    instructorImage:
      "https://images.pexels.com/photos/2898199/pexels-photo-2898199.jpeg",
    startDate: "Ongoing – Weekly",
    bannerImage:
      "/course3.avif",

    overview:
      "This course provides a comprehensive foundation in electrical installation and maintenance. Trainees will learn essential electrical principles, safe work practices, proper use of tools, and structured installation procedures used across residential, industrial, and commercial environments. The program combines theory with hands-on practice, focusing on cable terminations, conduits, distribution board components, testing methods, and fault identification. Participants will gain real-world competency to carry out electrical fitting tasks confidently and safely in compliance with industry standards ",

    suitableFor: "Electrical fitters, maintenance personnel",

    modeOfTraining: "Classroom Training",
    language: "English",
    ITECoCTitle: {
      level1: "CoC in Electrical Fitting – Level 1",
      level2: "CoC in Electrical Fitting – Level 2",
    },

    learningOutcomes: [
      "Understand workplace electrical safety requirements",
      "Perform hands-on installation tasks",
      "Pass mandatory WSQ proficiency assessment",
    ],
    soldCount: 420,

    curriculum: [
      "Electrical Safety Principles",
      "Installation and Maintenance Techniques",
      "Practical Assessment and Certification",
    ],

    certification: true,

    levels: {
      level1: {
        duration:
          "7 Hours (1h theory + 6h practical (includes 3 hours practical test))",
        price: 300,
        classRatio: "1:6",
        prerequisites: [
          "WSQ Electrical Fitting Work OR",
          "Composite Assessment for Generic Manufacturing (Process) OR",
          "Worker with R1 status through market-based",
        ],
      },
      level2: {
        duration:
          "21 Hours (5h theory + 16h practical (includes 5.5 hours practical test))",
        price: 900,
        classRatio: "1:6",
        prerequisites: [
          "WSQ Electrical Fitting Work OR",
          "ITE CoC in Electrical Fitting – Level 1",
        ],
      },
    },
  },
  // ======================================================================

  {
    id: "104",
    title: "Certificate of Competency in Rigging & Signaling ",
    instructor: "Certified Lifting Trainer",
    instructorImage:
      "https://images.unsplash.com/photo-1573497019418-b400bb3ab083?auto=format&fit=crop&w=300&q=80",
    startDate: "Ongoing – Weekly",
    bannerImage: "/product3.png",

    overview:
      "This course equips trainees with essential skills in safe rigging, lifting operations, and communication signals used in crane and hoisting activities. Participants will learn to assess loads, select rigging gear, prepare lifting zones, and coordinate safely with crane operators. The training covers hand signals, radio communication, load balancing principles, hazard anticipation, and emergency handling procedures. Through intensive practical sessions, learners gain the competence to support safe lifting operations at worksites and comply with MOM R1 requirements for riggers and signalmen.",

    suitableFor: "Suitable for riggers, signalmen, lifting supervisors",

    modeOfTraining: "Classroom Training",
    language: "English",
    ITECoCTitle: {
      level1: "CoC in Rigging & Signalling – Level 1",
      level2: "CoC in Rigging & Signalling – Level 2",
    },

    learningOutcomes: [
      "Safe rigging and lifting techniques",
      "Correct signal communication protocols",
      "Meet R1 Framework standards",
    ],
    soldCount: 960,

    curriculum: [
      "Rigging Equipment and Safety",
      "Signal Communication Standards",
      "Load Handling and Practical Assessment",
    ],

    certification: true,

    levels: {
      level1: {
        duration:
          "7 Hours (1.5h theory + 5.5h practical (including 2 hrs practical test))",
        price: 300,
        classRatio: "1:4",
        prerequisites: [
          "WSQ Perform Rigger and Signalman Tasks OR",
          "WSQ Perform Rigger and Signalman Tasks (PRST) from ATPs",
        ],
      },
      level2: {
        duration:
          "21 Hours (7h theory + 14h practical (including 3 hrs practical test))",
        price: 900,
        classRatio: "1:6",
        prerequisites: [
          "WSQ Perform Rigger and Signalman Tasks OR",
          "ITE CoC in Rigging & Signalling – Level 1",
        ],
      },
    },
  },

];
